import { statAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  statAnatomy.keys
);

const baseStyle = definePartsStyle({
  label: {
    color: "#171B1E",
    fontWeight: "600",
    fontSize: "20px",
    marginBottom: "8px",
  },
  helpText: {
    marginBottom: "0px",
  },
  container: {
    bg: "white",
    borderRadius: "12px",
    boxShadow: "0px 2px 8px 0px #00000014",
    px: "24px",
    py: "18px",
    w: "100%",
  },
  icon: {},
  number: {
    fontWeight: "700",
    fontSize: "30px",
    lineHeight: "100%",
  },
});

export const statTheme = defineMultiStyleConfig({ baseStyle });
